/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubmissionRequest } from './SubmissionRequest';
import {
    SubmissionRequestFromJSON,
    SubmissionRequestFromJSONTyped,
    SubmissionRequestToJSON,
    SubmissionRequestToJSONTyped,
} from './SubmissionRequest';

/**
 * 
 * @export
 * @interface JobInfo
 */
export interface JobInfo {
    /**
     * 
     * @type {string}
     * @memberof JobInfo
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof JobInfo
     */
    time: string;
    /**
     * 
     * @type {number}
     * @memberof JobInfo
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof JobInfo
     */
    title: string;
    /**
     * 
     * @type {SubmissionRequest}
     * @memberof JobInfo
     */
    request: SubmissionRequest;
}

/**
 * Check if a given object implements the JobInfo interface.
 */
export function instanceOfJobInfo(value: object): value is JobInfo {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('request' in value) || value['request'] === undefined) return false;
    return true;
}

export function JobInfoFromJSON(json: any): JobInfo {
    return JobInfoFromJSONTyped(json, false);
}

export function JobInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'time': json['time'],
        'status': json['status'],
        'title': json['title'],
        'request': SubmissionRequestFromJSON(json['request']),
    };
}

export function JobInfoToJSON(json: any): JobInfo {
    return JobInfoToJSONTyped(json, false);
}

export function JobInfoToJSONTyped(value?: JobInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'time': value['time'],
        'status': value['status'],
        'title': value['title'],
        'request': SubmissionRequestToJSON(value['request']),
    };
}

